// Admin navigation configuration - matching admin-web structure exactly
import { INavigationItem, IUserState, SELECTOR_OPTIONS } from '@/types/admin/navigation';

// Navigation items configuration (matching admin-web useMainNavItemsConfig exactly)
export const ADMIN_NAVIGATION_ITEMS: INavigationItem[] = [
  {
    id: 'community',
    path: '/residents',
    title: 'Community',
    subNavItems: [
      {
        path: '/residents',
        title: 'Residents',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/events',
        title: 'Events',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/bulletins',
        title: 'Bulletins',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/messages',
        title: 'Messages',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/resources',
        title: 'Resources',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/tasks',
        title: 'Tasks',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
    ],
  },
  {
    id: 'cork-board',
    path: '/tag-management',
    title: 'Newsfeed',
    subNavItems: [
      {
        path: '/tag-management',
        title: 'Tags',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/thread-moderation',
        title: 'Threads',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
      {
        path: '/report-review',
        title: 'Reports',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
    ],
  },
  {
    id: 'accounting',
    path: '/funding',
    title: 'Accounting',
    subNavItems: [
      {
        path: '/funding',
        title: 'Funding',
        displaySelectors: [SELECTOR_OPTIONS.property, SELECTOR_OPTIONS.organization],
      },
    ],
    condition: (user: IUserState) =>
      user.isSuperUser ||
      user?.roles?.some((role) =>
        ["Billing Admin", "Organization Admin", "Resio Admin"].includes(role.name),
      ) === true,
  },
  {
    id: 'organization',
    path: '/organizations',
    title: 'Organization',
    subNavItems: [
      {
        path: '/organizations',
        title: 'Organizations',
        condition: (user: IUserState) =>
          user.isSuperUser ||
          user?.roles?.some((role) => ["Resio Admin", "Organization Admin"].includes(role.name)) === true,
      },
      {
        path: '/user-management',
        title: 'Admin User Management',
      },
      {
        path: '/properties',
        title: 'Properties',
        condition: (user: IUserState) =>
          user.isSuperUser ||
          user?.roles?.some((role) => ["Resio Admin", "Organization Admin"].includes(role.name)) === true,
      },
    ],
  },
  {
    id: 'resio-admin',
    path: '/feature-flags',
    title: 'Resio Admin',
    subNavItems: [
      {
        path: '/feature-flags',
        title: 'Feature Flags',
      },
    ],
    condition: (user: IUserState) =>
      user.isSuperUser ||
      user?.roles?.some((role) => ["Resio Admin"].includes(role.name)) === true,
  },
];

// Default expanded menu (matching web behavior)
export const DEFAULT_EXPANDED_MENU = 'community';

// Default selected nav item (matching web behavior)
export const DEFAULT_SELECTED_NAV_ITEM = 'residents';

export const FUNDING_PATH = '/funding';